import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import '../utils/checkEnv';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from './common/error';
import '@arco-design/web-react/dist/css/arco.css';
import initSlardar from '@src/utils/slardar';
import Page from './page';
import './style/index.less';
import '../utils/tea';
initSlardar();
ReactDOM.render( /*#__PURE__*/React.createElement(ErrorBoundary, {
  FallbackComponent: ErrorFallback,
  onError: function onError() {
    return location.href = '/themes/error';
  }
}, /*#__PURE__*/React.createElement(BrowserRouter, {
  basename: "/themes"
}, /*#__PURE__*/React.createElement(Page, null))), document.getElementById('root'));